import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowLeft } from 'lucide-react';

export default function LegalLayout({ title, lastUpdated, children, testId = 'legal-page' }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid={testId} style={{ fontFamily: 'Outfit, sans-serif' }}>
      {/* Header */}
      <header className="border-b border-white/[0.06] bg-black/40 backdrop-blur-xl sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center shadow-lg shadow-orange-500/30">
              <Zap className="w-4 h-4 text-white" />
            </div>
            <span className="text-lg font-bold tracking-tight">Delphi</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-[12px] text-white/60 hover:text-white transition-colors" data-testid="legal-back">
            <ArrowLeft className="w-3.5 h-3.5" />Back to site
          </Link>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <div className="text-[11px] tracking-[0.35em] uppercase text-orange-400/70 font-semibold mb-3">Legal</div>
        <h1 className="text-4xl md:text-5xl font-light tracking-tighter mb-3" data-testid="legal-title">{title}</h1>
        <p className="text-[12px] text-white/40 mb-12">Last updated: {lastUpdated}</p>

        <div className="prose prose-invert prose-headings:font-light prose-headings:tracking-tight prose-headings:text-white prose-p:text-white/70 prose-p:leading-relaxed prose-li:text-white/70 prose-strong:text-white prose-a:text-orange-300 prose-a:no-underline hover:prose-a:underline max-w-none [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-[15px] [&_li]:text-[15px] [&_li]:my-1.5 [&_ul]:my-4 [&_ul]:pl-5 [&_ul]:list-disc">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-white/[0.05] text-center">
          <p className="text-[11px] tracking-[0.3em] uppercase text-white/30">&#10049; Delphi AI &middot; MMXXVI &#10049;</p>
        </div>
      </article>
    </div>
  );
}
